import { MetaData, FilterCategory } from 'uiComponents/filter/schema'
import { formatFlatOptions } from 'uiComponents/filter/filterHelpers'
import { t } from 'translations'

export const applicableFilters: FilterCategory[] = ['reservation_status', 'location_id']

// Labels are getters so they are translated when read, not when this module loads.
export const categoryOptions = {
    reservation_status: [
        {
            get name() {
                return t('orders.cart.filters.reservationStatus.open')
            },
            slug: 'open',
        },
        {
            get name() {
                return t('orders.cart.filters.reservationStatus.pending')
            },
            slug: 'pending',
        },
        {
            get name() {
                return t('orders.cart.filters.reservationStatus.initiated')
            },
            slug: 'initiated',
        },
        {
            get name() {
                return t('orders.cart.filters.reservationStatus.overdue')
            },
            slug: 'overdue',
        },
        {
            get name() {
                return t('orders.cart.filters.reservationStatus.expired')
            },
            slug: 'expired',
        },
        {
            get name() {
                return t('orders.cart.filters.reservationStatus.cancelled')
            },
            slug: 'cancelled',
        },
        {
            get name() {
                return t('orders.cart.filters.reservationStatus.completed')
            },
            slug: 'completed',
        },
    ],
}

export const getStaticMetadaCategories = (): MetaData[] => [
    {
        category: 'reservation_status' as FilterCategory,
        options: formatFlatOptions('reservation_status', categoryOptions.reservation_status),
    },
]
